// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block":"block_3vNW7","block__form":"block__form_1XwUB","block__text":"block__text_PsRa-","block_reversed":"block_reversed_33ANf"};